import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-add-subscription-license',
  templateUrl: './add-subscription-license.component.html',
  styleUrls: ['./add-subscription-license.component.css']
})
export class AddSubscriptionLicenseComponent extends BaseComponent implements OnInit {
  customer_id;
  addLicenseForm: FormGroup;
  getCompanyobj: any = [];
  categoryObj: any = [];
  submitted = false;
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService: MasterService
  ) { super(); }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.addLicenseForm = this.formBuilder.group({
      selectedCompany: [(this.customer_id == 0) ? this.getDefaultCompanyId() : this.customer_id, Validators.required],
      license_name: ['', [Validators.required, Validators.maxLength(255)]],
      license_code: ['', [Validators.required, Validators.maxLength(50)]],
      category_id: ['', Validators.required],
      category_order: [''],
      suggest_cost: ['']
    });
    if (this.addLicenseForm.value.selectedCompany) {
      this.loadCategories(this.addLicenseForm.value.selectedCompany);
    }
  }
  getCompany() {
    const self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      const working = self.bindWorkingCompany(self.getCompanyobj);
      if (working && !self.addLicenseForm.value.selectedCompany) {
        self.addLicenseForm.patchValue({ selectedCompany: working });
        self.loadCategories(working);
      }
    }, error => {
      console.log(error);
    });
  }
  onCompanyChange() {
    this.addLicenseForm.patchValue({ category_id: '' });
    this.loadCategories(this.addLicenseForm.value.selectedCompany);
  }
  loadCategories(companyId?) {
    const company = companyId || this.addLicenseForm.value.selectedCompany;
    this.categoryObj = [];
    if (!company) {
      return;
    }
    this.masterService.getLicenseCategoryList(company, 1000, 0, '', 'category_id', 'asc').subscribe(data => {
      if (data.status && data.data && data.data.rows) {
        this.categoryObj = data.data.rows;
      } else {
        this.categoryObj = [];
      }
    }, error => {
      console.log(error);
      this.categoryObj = [];
    });
  }
  get f() { return this.addLicenseForm.controls; }
  addNewLicense() {
    this.submitted = true;
    if (this.addLicenseForm.invalid) {
      return;
    }
    const { selectedCompany } = this.addLicenseForm.value;
    this.ngxSpinnerService.show();
    this.masterService.addLicenseCatalog(this.addLicenseForm.value, selectedCompany).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status) {
        this.toastrService.success('License added successfully');
        this.router.navigateByUrl('/corporate/subscription-license-list');
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }
}
